import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import { IUserMeeting } from "../../app/models/meeting";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericModal from "../common/GenericModal";

interface IParams {
  meeting: IUserMeeting | null;
  redirect: (url: string) => void;
}

const MeetingAttendanceModal: React.FC<IParams> = ({ meeting, redirect }) => {
  const rootStore = useContext(RootStoreContext);
  const { hideMeetingAttendanceModal,enabledRepository } = rootStore.playerStore;
  const { attendMeeting , canViewODG, } = rootStore.tenantStore;
  const { updateDocumentalView, broadcastOpeningEvaluation} = rootStore.meetingStore;
  const [t] = useTranslation(["features"], translationHookOptions);
  const { isMobileMediaQuery } = rootStore.responsiveStore;

  const getAttendMeetingButton = (meetingId: number) => {
    return {
      index:0,
      text: t("meeting_inprogress_modal_participate"),
      action: async () => {
        if (meeting) {
          await attendMeeting(meetingId).then(() =>
           {  
            updateDocumentalView(false);
            if(canViewODG){
              redirect(`meeting/${meetingId}`)
            }
            else
            {
              if(enabledRepository)
                redirect(`repository`)
              else
                redirect(`board`)
            }
          }
          );
          broadcastOpeningEvaluation();
        }
      }
    };
  };

  const getAnonymousButton = (meetingId: number) => {
    return {
      index:1,
      text: t("meeting_inprogress_modal_anonymous"),
      action: () => redirect(`meeting/${meetingId}`),
      color: "light",
    };
  };

  const getPodiumButton = (meetingId: number) => {
    return {
      index:2,
      text: t("meeting_inprogress_modal_podium"),
      action: async () => {
        if (meeting) {
          await attendMeeting(meetingId).then(() =>
            redirect(`meeting/${meetingId}/podium`)
          );
        }
      },
      color: "light"
    };
  };

  const getAvailableButtons = (meeting: IUserMeeting) => {
    let buttons = [
       getAttendMeetingButton(meeting.id),
       getAnonymousButton(meeting.id)
    ];
if (meeting.hasEnabledPodium) buttons.push(getPodiumButton(meeting.id));
 if(!canViewODG) { buttons.splice(1,1)} // nel caso in cui ODG è disabilitato non devo fare vedere il bottone "CONSULTA ODG"
    return buttons;
  };

  const Test =()=> {
    if(canViewODG)
   return t("meeting_inprogress_modal_body")
   else
   return t("meeting_inprogress_modal_body_No_ODG");
  }

  return (
    <>
      {meeting ? (
        <GenericModal
          isOpen={meeting ? true : false}
          toggle={hideMeetingAttendanceModal}
          title={`${t("meeting_inprogress_modal_title")} ${
            meeting ? meeting.title : ""
          }`}
          content={Test()}
          actions={getAvailableButtons(meeting)}
          size="md"
          isMobile={isMobileMediaQuery}
          modalHeaderClass="meetingAttendanceHeader"
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default observer(MeetingAttendanceModal);
